import { useRoutes } from "react-router-dom";

import { Routes } from "@/routes";

export const App = () => {
    const routes = useRoutes(Routes);

    return routes;
};
